import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LaminationService } from '@app/shared/services/lamination.service';
import { TempProductionService } from '@app/shared/services/temp-production.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

import * as XLSX from 'xlsx';


@Component({
  selector: 'app-printing-test-table',
  templateUrl: './printing-test-table.component.html',
  styleUrls: ['./printing-test-table.component.css']
})
export class PrintingTestTableComponent implements OnInit {
  
 
   //table
   materialMixEntries: any[] = [];
   currentPage: number = 1;
   itemsPerPage: number = 25;
 
 
   
  
    totalPages: number = 1;
   //  by date
   searchDate: string = '';  // For storing selected date






   tempPrintingData: any[] = [];  // Store the fetched temp printing data


   // New filter variables
  searchOperator: string = '';
  searchShift: string = '';
  searchMachine: string = '';
  searchClient: string = '';
  searchJobName: string = '';
  searchFromDate: string = '';
  searchToDate: string = '';

  searchTicket: string = '';
 

 constructor( private laminationService: LaminationService, private cdr: ChangeDetectorRef, private activatedRoute: ActivatedRoute,private tempProductionService: TempProductionService,) { }

 ngOnInit(): void {
  //  this.loadAllLaminationProductions();

   this.loadTempPrintingData();  // Load the data when the component initializes
 }

allTempPrintingData: any[] = [];
// Method to load Temp Printing Data
loadTempPrintingData(): void {
  this.tempProductionService.getTempPrinting().subscribe(
    (data) => {
      console.log('Loaded Temp Printing Data:', data);
      if (Array.isArray(data)) {
        // this.tempPrintingData = data.reverse();  // Reverse the array before assigning it;  // Assign data to the variable;  // Assign data to the variable
        this.allTempPrintingData = [...data].reverse();
this.tempPrintingData = [...this.allTempPrintingData];
        this.totalPages = Math.ceil(this.tempPrintingData.length / this.itemsPerPage);
        this.updatePaginatedTempPrintingData();

        this.filterTable();

//for implementing searchable dropdown
// client name
        this.clientNames = [
        ...new Set(
          this.tempPrintingData
            .map(x => x.clientName)
            .filter(Boolean)
        )
      ];
      // 
this.shiftNames = [
  ...new Set(
    this.tempPrintingData
      .map(x => x.shift)
      .filter(Boolean)
  )
];

this.machineNames = [
  ...new Set(
    this.tempPrintingData
      .map(x => x.machine)
      .filter(Boolean)
  )
];

this.jobNames = [
  ...new Set(
    this.tempPrintingData
      .map(x => x.jobName)
      .filter(Boolean)
  )
];

this.ticketNumbers = [
  ...new Set(
    this.tempPrintingData
      .map(x => x.ticketNo)
      .filter(Boolean)
  )
];

this.refNumbers = [
  ...new Set(
    this.tempPrintingData
      .map(x => x.refNo)
      .filter(Boolean)
  )
];
      // 
      }

      this.cdr.detectChanges();
    },
    (error) => {
      console.error('Error loading Temp Printing Data:', error);
    }
  );
}

//for implementing searchable dropdown
clientNames: string[] = [];

shiftNames: string[] = [];
machineNames: string[] = [];
jobNames: string[] = [];
ticketNumbers: string[] = [];
refNumbers: string[] = [];
// 
searchRefNo: string = '';

paginatedTempPrintingData: any[] = [];

updatePaginatedTempPrintingData(): void {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.paginatedTempPrintingData = this.tempPrintingData.slice(startIndex, endIndex);
}

goToPage(page: number): void {
  if (page < 1 || page > this.totalPages) return;
  this.currentPage = page;
  this.updatePaginatedTempPrintingData();
}







 // Filter method to apply the filters on the data
 filterTable(): void {
  console.log('From Date:', this.searchFromDate);
console.log('To Date:', this.searchToDate);
console.log('First Record Date:', this.tempPrintingData[0]?.date);

  // this.loadTempPrintingData();
  // let filteredData = this.tempPrintingData;
  let filteredData = [...this.allTempPrintingData];

  // Apply each filter if present
  if (this.searchOperator) {
    filteredData = filteredData.filter(entry => 
      (entry.operator?.toLowerCase() || '').includes(this.searchOperator.toLowerCase())
    );
  }
  if (this.searchShift) {
    filteredData = filteredData.filter(entry => 
      (entry.shift?.toLowerCase() || '').includes(this.searchShift.toLowerCase())
    );
  }
  if (this.searchMachine) {
    filteredData = filteredData.filter(entry => 
      (entry.machine?.toLowerCase() || '').includes(this.searchMachine.toLowerCase())
    );
  }
  if (this.searchClient) {
    filteredData = filteredData.filter(entry => 
      (entry.clientName?.toLowerCase() || '').includes(this.searchClient.toLowerCase())
    );
  }
  if (this.searchJobName) {
    filteredData = filteredData.filter(entry => 
      (entry.jobName?.toLowerCase() || '').includes(this.searchJobName.toLowerCase())
    );
  }
  if (this.searchFromDate) {
    filteredData = filteredData.filter(entry => 
      new Date(entry.date) >= new Date(this.searchFromDate)
    );
  }
  if (this.searchToDate) {
    filteredData = filteredData.filter(entry => 
      new Date(entry.date) <= new Date(this.searchToDate)
    );
  }
   // Manually filter by From and To Date
   // Manually filter by From and To Date
  //  if (this.searchFromDate) {
  //   const fromDate = this.convertDateFormatForComparison(this.searchFromDate);
  //   filteredData = filteredData.filter(entry => 
  //     new Date(entry.date.split('-').reverse().join('-')) >= new Date(fromDate)
  //   );
  // }
  // if (this.searchToDate) {
  //   const toDate = this.convertDateFormatForComparison(this.searchToDate);
  //   filteredData = filteredData.filter(entry => 
  //     new Date(entry.date.split('-').reverse().join('-')) <= new Date(toDate)
  //   );
  // }

  if (this.searchTicket) {
    filteredData = filteredData.filter(entry => 
      (entry.ticketNo?.toLowerCase() || '').includes(this.searchTicket.toLowerCase())
    );
  }

  if (this.searchRefNo) {
  filteredData = filteredData.filter(entry =>
    (entry.refNo?.toLowerCase() || '')
      .includes(this.searchRefNo.toLowerCase())
  );
}

  // Update filtered entries and pagination
  this.tempPrintingData = filteredData;
  this.totalPages = Math.ceil(this.tempPrintingData.length / this.itemsPerPage);
  this.updatePaginatedTempPrintingData();

   // ✅ ADD THIS
  this.cdr.detectChanges();
}

 // Convert date in dd-mm-yyyy format to yyyy-mm-dd for comparison
 convertDateFormatForComparison(date: string): string {
  // const [day, month, year] = date.split('-');
  // return `${year}-${month}-${day}`;
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}
// Format date from yyyy-mm-dd to dd-mm-yyyy for display
formatDateForDisplay(date: string): string {
  const [year, month, day] = date.split('-');
  return `${day}-${month}-${year}`;
}


// Export to Excel
// exportToExcel(): void {
//   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.tempPrintingData); // Convert data to sheet
//   const wb: XLSX.WorkBook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, 'Printing Records'); // Append sheet to workbook
//   XLSX.writeFile(wb, 'printing_records.xlsx'); // Download as .xlsx file
// }

clearFilters(): void {
  // Reset all filter variables
  this.searchOperator = '';
  this.searchShift = '';
  this.searchMachine = '';
  this.searchClient = '';
  this.searchJobName = '';
  this.searchFromDate = '';
  this.searchToDate = '';
  this.searchTicket = '';

  this.searchRefNo = '';

  // Reload the original data
  this.loadTempPrintingData(); // This will reset the table to unfiltered data

  // Reset pagination
  this.currentPage = 1;
  this.totalPages = Math.ceil(this.tempPrintingData.length / this.itemsPerPage);
  this.updatePaginatedTempPrintingData();

  // Trigger change detection
  this.cdr.detectChanges();
}








// working properly without total
// exportToExcel(): void {
//   // Prepare filter data dynamically (only include applied filters)
//   const appliedFilters = [];
//   if (this.searchOperator) appliedFilters.push(` Operator: ${this.searchOperator}`);
//   if (this.searchShift) appliedFilters.push(`Shift: ${this.searchShift}`);
//   if (this.searchMachine) appliedFilters.push(` Machine: ${this.searchMachine}`);
//   if (this.searchClient) appliedFilters.push(` Client: ${this.searchClient}`);
//   if (this.searchJobName) appliedFilters.push(` Job Name: ${this.searchJobName}`);
//   if (this.searchFromDate) appliedFilters.push(`From Date: ${this.searchFromDate}`);
//   if (this.searchToDate) appliedFilters.push(`To Date: ${this.searchToDate}`);

//   // Prepare filter header for Excel
//   const filterHeader = appliedFilters.length > 0 ? ['Applied Filters', ...appliedFilters] : [];

//   // Prepare data to export (you can include both the filters and the actual data)
//   const exportData = [];

//   if (filterHeader.length > 0) {
//     exportData.push(filterHeader);  // Add filters as the first row
//   }

//   // Add the data rows (you can customize the headers as needed)
//   const dataHeader = this.columns.filter(column => column.visible).map(column => column.label);
//   exportData.push(dataHeader);

//   // Add the data rows (with values from `paginatedTempPrintingData`)
//   this.paginatedTempPrintingData.forEach(entry => {
//     const row = this.columns.filter(column => column.visible).map(column => entry[column.field] || '');
//     exportData.push(row);
//   });

//   // Create the worksheet from the data
//   const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportData); // Convert data array to sheet

//   // Set column widths based on the content
//   const columnWidths = this.columns.filter(column => column.visible).map((column, index) => {
//     // Find the maximum content length in the column (both header and data)
//     let maxLength = column.label.length; // Start with header length
//     for (let rowIndex = 1; rowIndex < exportData.length; rowIndex++) {
//       const cellValue = exportData[rowIndex][index];
//       if (cellValue && cellValue.length > maxLength) {
//         maxLength = cellValue.length;
//       }
//     }
//     // Set width with a bit of buffer (you can adjust the multiplier if needed)
//     return { wpx: (maxLength + 2) * 12 }; // 7 is the scaling factor for width
//   });

//   // Assign column widths to the worksheet
//   ws['!cols'] = columnWidths;

//   // Create a new workbook and append the worksheet
//   const wb: XLSX.WorkBook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, 'Printing Records'); // Append sheet to workbook

//   // Write and download the Excel file
//   XLSX.writeFile(wb, 'printing_records.xlsx');
// }
exportToExcel(): void {
  // Prepare filter data dynamically (only include applied filters)
  const appliedFilters = [];
  if (this.searchOperator) appliedFilters.push(`Operator: ${this.searchOperator}`);
  if (this.searchShift) appliedFilters.push(`Shift: ${this.searchShift}`);
  if (this.searchMachine) appliedFilters.push(`Machine: ${this.searchMachine}`);
  if (this.searchClient) appliedFilters.push(`Client: ${this.searchClient}`);
  if (this.searchJobName) appliedFilters.push(`Job Name: ${this.searchJobName}`);

  if (this.searchTicket) appliedFilters.push(`Job Name: ${this.searchTicket}`);
  if (this.searchFromDate) appliedFilters.push(`From Date: ${this.searchFromDate}`);
  if (this.searchToDate) appliedFilters.push(`To Date: ${this.searchToDate}`);

  const exportData: any[][] = [];

  // Add applied filters as rows (each filter on its own row)
  appliedFilters.forEach(filter => {
    exportData.push([filter]);
  });

  // Prepare header row
  const visibleColumns = this.columns.filter(col => col.visible);
  const headerRow = visibleColumns.map(col => col.label);
  exportData.push(headerRow);

  // Add data rows
  this.paginatedTempPrintingData.forEach(entry => {
    const row = visibleColumns.map(col => entry[col.field] || '');
    exportData.push(row);
  });

  // Add totals row aligned with columns
  const totalRow: any[] = visibleColumns.map(col => {
    if (col.totalable) {
      // Calculate total for this column
      const total = this.paginatedTempPrintingData.reduce((sum, entry) => {
        return sum + (parseFloat(entry[col.field]) || 0);
      }, 0);
      return total.toFixed(2); // format numbers
    }
    return ''; // empty for non-totalable columns
  });

  // Only add total row if there is at least one totalable column
  if (totalRow.some(cell => cell !== '')) {
    exportData.push(totalRow);
  }

  // Create worksheet
  const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportData);

  // Set column widths
  ws['!cols'] = visibleColumns.map((col, index) => {
    let maxLength = col.label.length;
    for (let r = 0; r < exportData.length; r++) {
      const cellValue = exportData[r][index];
      if (cellValue && cellValue.toString().length > maxLength) {
        maxLength = cellValue.toString().length;
      }
    }
    return { wpx: (maxLength + 2) * 12 };
  });

  // Create workbook and export
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Printing Records');
  XLSX.writeFile(wb, 'printing_records.xlsx');
}








// exportToExcel(): void {
//   // Prepare filter data dynamically (only include applied filters)
//   const appliedFilters = [];
//   if (this.searchOperator) appliedFilters.push(`Filter by Operator: ${this.searchOperator}`);
//   if (this.searchShift) appliedFilters.push(`Filter by Shift: ${this.searchShift}`);
//   if (this.searchMachine) appliedFilters.push(`Filter by Machine: ${this.searchMachine}`);
//   if (this.searchClient) appliedFilters.push(`Filter by Client: ${this.searchClient}`);
//   if (this.searchJobName) appliedFilters.push(`Filter by Job Name: ${this.searchJobName}`);
//   if (this.searchFromDate) appliedFilters.push(`Filter From Date: ${this.searchFromDate}`);
//   if (this.searchToDate) appliedFilters.push(`Filter To Date: ${this.searchToDate}`);

//   // Prepare filter header for Excel
//   const filterHeader = appliedFilters.length > 0 ? ['Applied Filters', ...appliedFilters] : [];

//   // Prepare data to export (you can include both the filters and the actual data)
//   const exportData = [];

//   if (filterHeader.length > 0) {
//     exportData.push(filterHeader);  // Add filters as the first row
//   }

//   // Add the data rows (you can customize the headers as needed)
//   const dataHeader = this.columns.filter(column => column.visible).map(column => column.label);
//   exportData.push(dataHeader);

//   // Add the data rows (with values from `paginatedTempPrintingData`)
//   this.paginatedTempPrintingData.forEach(entry => {
//     const row = this.columns.filter(column => column.visible).map(column => entry[column.field] || '');
//     exportData.push(row);
//   });

//   // Create the worksheet from the data
//   const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportData); // Convert data array to sheet
  
//   // Create a new workbook and append the worksheet
//   const wb: XLSX.WorkBook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, 'Printing Records'); // Append sheet to workbook

//   // Write and download the Excel file
//   XLSX.writeFile(wb, 'printing_records.xlsx');
// }











 












// getTotal(fieldName: string): number {
//   return this.tempPrintingData.reduce((total, entry) => {
//     const value = parseFloat(entry[fieldName]) || 0; // Safely parse the value, default to 0 if NaN
//     return total + value;
//   }, 0);
// }



 // Column definitions with visibility flag
//  columns = [
//   { label: 'Ticket No', field: 'ticketNo', visible: true },
//   { label: 'Job Name', field: 'jobName', visible: true },
//   { label: 'Date', field: 'date', visible: true },
//   { label: 'Ref No', field: 'refNo', visible: true },
//   { label: 'PO Number', field: 'poNumber', visible: true },
//   { label: 'Client Name', field: 'clientName', visible: true },
//   { label: 'Operator', field: 'operator', visible: true },
//   { label: 'Shift', field: 'shift', visible: true },
//   { label: 'Machine', field: 'machine', visible: true },
//   { label: 'Used Size', field: 'usedSize', visible: true },
//   { label: 'Input', field: 'input', visible: true },
//   { label: 'Output', field: 'output', visible: true },
//   { label: 'Material', field: 'material', visible: true },
//   { label: 'Thickness', field: 'thickness', visible: true },
//   { label: 'Width', field: 'width', visible: true },
//   { label: 'Wastage', field: 'wastage', visible: true },
//   { label: 'Consumed', field: 'consumed', visible: true },
//   { label: 'Total Sol', field: 'totalSol', visible: true },
//   { label: 'Extra', field: 'extra', visible: true }
// ];
// Columns definition with visibility and totalable flag
columns = [
  // { label: 'Ticket No', field: 'ticketNo', visible: true, totalable: false },
  // { label: 'Job Name', field: 'jobName', visible: true, totalable: false },
  // { label: 'Date', field: 'date', visible: true, totalable: false },
  // { label: 'Ref No', field: 'refNo', visible: true, totalable: false },
  // { label: 'PO Number', field: 'poNumber', visible: true, totalable: false },
  // { label: 'Client Name', field: 'clientName', visible: true, totalable: false },
  // { label: 'Operator', field: 'operator', visible: true, totalable: false },
  // { label: 'Shift', field: 'shift', visible: true, totalable: false },
  // { label: 'Machine', field: 'machine', visible: true, totalable: false },
  // { label: 'Used Size', field: 'usedSize', visible: true, totalable: true },
  // { label: 'Input', field: 'input', visible: true, totalable: true },
  // { label: 'Output', field: 'output', visible: true, totalable: true },
  // { label: 'Material', field: 'material', visible: true, totalable: false },
  // { label: 'Thickness', field: 'thickness', visible: true, totalable: true },
  // { label: 'Width', field: 'width', visible: true, totalable: true },
  // { label: 'Wastage', field: 'wastage', visible: true, totalable: true },
  // { label: 'Consumed', field: 'consumed', visible: true, totalable: true },
  // { label: 'Total Sol', field: 'totalSol', visible: true, totalable: true },
  // { label: 'Extra', field: 'extra', visible: true, totalable: true }

  { label: 'Ticket No', field: 'ticketNo', visible: true, totalable: false },
  { label: 'Job Name', field: 'jobName', visible: true, totalable: false },
  { label: 'Date', field: 'date', visible: true, totalable: false },
  { label: 'Ref No', field: 'refNo', visible: true, totalable: false },
  { label: 'PO Number', field: 'poNumber', visible: true, totalable: false },
  { label: 'Client Name', field: 'clientName', visible: true, totalable: false },
  { label: 'Operator', field: 'operator', visible: true, totalable: false },
  { label: 'Shift', field: 'shift', visible: true, totalable: false },
  { label: 'Machine', field: 'machine', visible: true, totalable: false },

  { label: 'Material', field: 'material', visible: true, totalable: false },
  { label: 'Thickness', field: 'thickness', visible: true, totalable: true },
  { label: 'Width', field: 'width', visible: true, totalable: true },
  { label: 'Used Size', field: 'usedSize', visible: true, totalable: true },
  { label: 'Input', field: 'input', visible: true, totalable: true },
  { label: 'Output', field: 'output', visible: true, totalable: true },
 
  { label: 'Wastage', field: 'wastage', visible: true, totalable: true },
  { label: 'Consumed', field: 'consumed', visible: true, totalable: true },
  { label: 'Total Sol', field: 'totalSol', visible: true, totalable: true },
  { label: 'Extra', field: 'extra', visible: true, totalable: true }
];

 // Function to remove a column based on index
 removeColumn(index: number): void {
  // Set the visibility of the column to false (hidden)
  this.columns[index].visible = false;
  this.cdr.detectChanges();  // Ensure the view gets updated
}

// Method to get the total for a specific field, only for "totalable" columns
getTotal(fieldName: string): number {
  const column = this.columns.find(col => col.field === fieldName);
  if (column && column.totalable) {
    return this.tempPrintingData.reduce((total, entry) => {
      const value = parseFloat(entry[fieldName]) || 0;
      return total + value;
    }, 0);
  }
  return 0;
}


 





// Method to print the entire table, including filters and totals
// Method to print the entire table, including filters and totals
// Method to print the entire table, including filters and totals
printMaterialIssue() {
  const printWindow = window.open('', '_blank');

  if (printWindow) {
    // Prepare the content for printing
    const printContent = `
      <html>
        <head>
          <title>Printing Records</title>
          <style>
            @media print {
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              h6 {
                text-align: center;
                font-size: 20px;
                font-weight: bold;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 20px;
              }
              th, td {
                padding: 8px;
                text-align: left;
                border: 1px solid black;
              }
              th {
                background-color: #f2f2f2;
                font-weight: bold;
              }
              .filters {
                margin-top: 20px;
              }
              .filters div {
                margin-bottom: 5px;
              }
              .total-row td {
                font-weight: bold;
              }
              .no-data {
                text-align: center;
                font-size: 16px;
                margin-top: 20px;
              }
            }
          </style>
        </head>
        <body>
          <h6>Printing Records</h6>
          
         
           <div class="filters">
            <!-- Only include filter sections that have a value -->
            ${this.searchOperator ? `<div><strong>Filter by Operator:</strong> ${this.searchOperator}</div>` : ''}
            ${this.searchShift ? `<div><strong>Filter by Shift:</strong> ${this.searchShift}</div>` : ''}
            ${this.searchMachine ? `<div><strong>Filter by Machine:</strong> ${this.searchMachine}</div>` : ''}
            ${this.searchClient ? `<div><strong>Filter by Client:</strong> ${this.searchClient}</div>` : ''}
            ${this.searchJobName ? `<div><strong>Filter by Job Name:</strong> ${this.searchJobName}</div>` : ''}
            ${this.searchFromDate ? `<div><strong>Filter From Date:</strong> ${this.searchFromDate}</div>` : ''}
            ${this.searchToDate ? `<div><strong>Filter To Date:</strong> ${this.searchToDate}</div>` : ''}
          </div>


          
          
          <table>
            <thead>
              <tr>
                ${this.columns.filter(column => column.visible).map(column => `
                  <th>${column.label}</th>
                `).join('')}
              </tr>
            </thead>
            <tbody>
              ${this.paginatedTempPrintingData.map((entry, index) => `
                <tr>
                  ${this.columns.filter(column => column.visible).map(column => `
                    <td>${entry[column.field] || ''}</td>
                  `).join('')}
                </tr>
              `).join('')}
            </tbody>
            <tfoot>
              <tr class="total-row">
               
                <td colspan="10" style="text-align: right;">Total:</td>
                ${this.columns.filter(column => column.visible && column.totalable).map(column => `
                  <td>${this.getTotal(column.field) || 0}</td>
                `).join('')}
              </tr>
            </tfoot>
          </table>
          
          <div class="no-data" ${this.paginatedTempPrintingData.length === 0 ? '' : 'style="display:none"'}>
            No temporary production data available.
          </div>
        </body>
      </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
      // setTimeout(() => window.close(), 1000)
  }
}

// <td colspan="${this.columns.filter(column => column.visible).length - 1}" style="text-align: right;">Total:</td>


// <div class="filters">
// <div><strong>Filter by Operator:</strong> ${this.searchOperator || 'Not Applied'}</div>
// <div><strong>Filter by Shift:</strong> ${this.searchShift || 'Not Applied'}</div>
// <div><strong>Filter by Machine:</strong> ${this.searchMachine || 'Not Applied'}</div>
// <div><strong>Filter by Client:</strong> ${this.searchClient || 'Not Applied'}</div>
// <div><strong>Filter by Job Name:</strong> ${this.searchJobName || 'Not Applied'}</div>
// <div><strong>Filter From Date:</strong> ${this.searchFromDate || 'Not Applied'}</div>
// <div><strong>Filter To Date:</strong> ${this.searchToDate || 'Not Applied'}</div>
// </div>




printGlueingData() {
  const printContents =
    document.getElementById('printingPrintTable')?.outerHTML;

  if (!printContents) {
    alert('No data available to print.');
    return;
  }

  const printWindow =
    window.open('', '_blank', 'width=1200,height=800');

  if (!printWindow) {
    alert('Please allow pop-ups to print.');
    return;
  }

  printWindow.document.open();

  printWindow.document.write(`
    <html>
      <head>
        <title>Printing Records</title>

        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }

          h2 {
            text-align: center;
            margin-bottom: 20px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 8px;
          }

          th,
          td {
            border: 1px solid #000;
            padding: 5px;
            text-align: center;
          }

          th {
            background-color: #f2f2f2;
            font-weight: bold;
          }

          tfoot td {
            font-weight: bold;
          }

          @media print {

            body {
              margin: 0;
            }

            table {
              width: 100%;
              page-break-inside: auto;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            thead {
              display: table-header-group;
            }

            tfoot {
              display: table-footer-group;
            }

            @page {
              size: landscape;
              margin: 10mm;
            }
          }
        </style>
      </head>

      <body>

        <h2>Printing Records</h2>

        ${printContents}

      </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
}
 



}
